import React from "react";
import PropTypes from "prop-types";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";

/**
 * Pestañas de un detalle dentro de un modal, manejadas por datos.
 *
 * No sirve MenuModulo: aquel usa la clase `menu_modulo`, que el CSS global
 * define como barra lateral fija de 90px para las pantallas del modulo. La de
 * un modal es `menu_modal`, que las pinta en fila y subraya la activa, igual
 * que el detalle de solicitudes de Procesos Academicos.
 */
const MenuDetalle = ({ opciones, seleccion, onSeleccionar }) => (
  <div className="menu_modal">
    <BottomNavigation showLabels>
      {opciones.map(({ codigo, label, Icono }) => (
        <BottomNavigationAction
          key={codigo}
          label={label}
          icon={<Icono />}
          className={codigo === seleccion ? "item_selec" : "item_modulo"}
          onClick={() => onSeleccionar(codigo)}
        />
      ))}
    </BottomNavigation>
  </div>
);

MenuDetalle.propTypes = {
  opciones: PropTypes.arrayOf(
    PropTypes.shape({
      codigo: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      Icono: PropTypes.elementType.isRequired,
    }),
  ).isRequired,
  seleccion: PropTypes.string.isRequired,
  onSeleccionar: PropTypes.func.isRequired,
};

export default MenuDetalle;
